export enum PermissionType {
	NONE,
	NO_ACCESS,
	WRITE,
	READ
}

export const SYSTEM_USER_ID = 0xFFFFFFFF;
export const NEW_DEVICES_SITE = 1;
export const SCT_INVENTORY_SITE_ID = 2;
export const SCT_CUSTOMER_ID = 1;
export const FLOAT_VALUE_LIMIT = 3.4E+38;
export const TESTING_TIMER_WAIT = 45000; //45s

export const FIRST_FW_VERSION_WITH_OAEP = 1.2900;

export enum IM_SCT_DEVICE_TYPES {
	SinglePhase = 100,
	ThreePhaseInternal = 101,
	ThreePhaseExternal = 102,
	AcuRev = 103,
};